import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { GetNotificationsResponse } from "@src/types/support";

export interface GetNotificationsResult {
  success: boolean;
  data?: GetNotificationsResponse;
  error?: string;
}

export const getAlarmsAndNotificationsUseCase =
  async (): Promise<GetNotificationsResult> => {
    try {
      const namespace =
        store.getState().yourSlice.authContext.customerNamespace;
      const response = await apiUseCases.getAlarmsAndNotifications(namespace);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: parseAxiosApiError(error, "Failed to fetch notifications")
          .message,
      };
    }
  };
